if (!window.beaePageJS) {
                                    window.beaePageJS = [];
                                }
                                let jsHandle_61f163c6f2923873f671b106 = () => {

            (function() {this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.jQuery(this.$el).find("[data-beae-popup]").beaePopup({type:"image"})}).call({
                $el: document.querySelector('.beae-co3n1rb7'),
                settings: {"link":"lightbox","lightbox":"no"},
                id: 'beae-co3n1rb7',
                isLive: true
            });
        
            (function() {this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.jQuery(this.$el).find("[data-beae-popup]").beaePopup({type:"image"})}).call({
                $el: document.querySelector('.beae-ts9jdlw6'),
                settings: {"link":"lightbox","lightbox":"no"},
                id: 'beae-ts9jdlw6',
                isLive: true
            });
        
            (function() {this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.jQuery(this.$el).find("[data-beae-popup]").beaePopup({type:"image"})}).call({
                $el: document.querySelector('.beae-6tfemldz'),
                settings: {"link":"lightbox","lightbox":"no"},
                id: 'beae-6tfemldz',
                isLive: true
            });
        }
                                if (window.beaejQuery) {
                                    jsHandle_61f163c6f2923873f671b106()
                                } else {
                                    window.beaePageJS.push(jsHandle_61f163c6f2923873f671b106)
                                }